var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.patients,"items-per-page":10},scopedSlots:_vm._u([{key:"item.mrn",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":("/patient/" + (item.site_id) + "/" + (item.id))}},[_vm._v(" "+_vm._s(item.mrn)+" ")])]}},{key:"item.patient_link",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":("/patient/" + (item.site_id) + "/" + (item.id))}},[_vm._v(" "+_vm._s(_vm.getPatientLink(item))+" ")])]}},{key:"item.remove",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.removePatient(item.id)}}},[_c('v-icon',[_vm._v("mdi-close-circle")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }